import React from "react";
import { Header as BronsonHeader, ContextBar, Logo } from "@vwfs-bronson/bronson-react";
import { EntryPoint } from "@busdk/storefront-service/dist/models/enums";
import { AbortModal } from "../AbortModal";

export const Header = ({
  title,
  actionHeading,
  actionLabel,
  onContact,
  abortModalShown,
  redirectUrl,
  setAbortModalShown,
  transactionId,
  productModifier,
  isVtiBOP,
  isDataLoaded,
}) => {
  const shouldShowAbort = false;
  /*process.env.REACT_APP_BRAND !== "vwfs" &&
    process.env.REACT_APP_BRAND !== "vwn";*/
  return (
    <>
      <BronsonHeader
        staticHeader
        logo={

          <div style={{ display: 'flex', maxHeight: '70px' }}>
            <Logo
              testId="appHeaderLogo"
              breakpoint="720px"
            />
            {isVtiBOP && isDataLoaded &&(
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/VWFS_SOB_Picto_Gebrauchtwagen_RGB_1row_left_aligned.svg`}
                alt="gebrauchtwagen logo"
                testid="gebrauchtwageLogo"
                style={{ width: '50%' }}
              />
            )}
          </div>
        }
      >
        <ContextBar>
          <ContextBar.SiteNav>
            <ContextBar.SiteNav.Item title noLink label={title} />
          </ContextBar.SiteNav>

          <ContextBar.SiteNav>
            <ContextBar.SiteNav.Item title noLink label={actionLabel} />
            <ContextBar.SiteNav.Item>
              <ContextBar.SiteNav.Item.ContextItem
                contextBarIcon="semantic-chat"
                onClick={onContact}
                iconLabel={actionHeading}
                normalLink
                testid="contact-button"
              />

              {shouldShowAbort && (
                <ContextBar.SiteNav.Item.ContextItem
                  contextBarIcon="semantic-close"
                  onClick={() => {
                    setAbortModalShown(true);
                  }}
                  normalLink
                  testid="abort-button"
                />
              )}
            </ContextBar.SiteNav.Item>

            {process.env.REACT_APP_ENTRYPOINT === EntryPoint.HEYCAR &&
              !isVtiBOP &&
              isDataLoaded && (
                <li>
                  <img
                    className="u-hide@s u-ml"
                    src={`${process.env.PUBLIC_URL}/assets/images/heycar_logo.png`}
                    width="100"
                    alt="Co branding logo"
                  />
                </li>
              )}
          </ContextBar.SiteNav>
        </ContextBar>
        {shouldShowAbort && (
          <AbortModal
            shown={abortModalShown}
            redirectUri={redirectUrl}
            setShown={setAbortModalShown}
            transactionId={transactionId}
            productModifier={productModifier}
          />
        )}
      </BronsonHeader>
      {process.env.REACT_APP_ENTRYPOINT === EntryPoint.HEYCAR &&
        !isVtiBOP &&
        isDataLoaded && (
          <div style={{ marginTop: "-1em" }}>
            <img
              className="u-hide@s-up u-ml-small"
              width="90"
              src={`${process.env.PUBLIC_URL}/assets/images/heycar_logo.png`}
              alt="Co branding logo"
            />
          </div>
        )}
    </>
  );
};
